import React from 'react';
import { User, Home } from 'lucide-react';
import CustomSelect from './CustomSelect';
import { getAccountTypeIcon } from '../../utils/formatters';
import './AccountSelect.css';

/**
 * Specialized dropdown for selecting payment accounts with card image previews
 * Built on top of CustomSelect
 */
function AccountSelect({ 
  accounts, 
  value, 
  onChange, 
  name = 'paymentAccountId',
  disabled = false, 
  placeholder = 'Select account...',
  showOwnership = false 
}) {
  // Transform accounts into options format for CustomSelect
  const options = accounts.map(account => {
    const lastFour = account.last_four || account.last_four_digits;
    const showLastFour = lastFour && !account.account_name.includes(lastFour);
    const label = `${account.account_name}${showLastFour ? ` (••${lastFour})` : ''}`;
    
    return {
      value: account.id.toString(),
      label,
      icon: getAccountTypeIcon(account.account_type),
      cardImage: account.card_image, // Add card image to option
      badge: showOwnership ? (
        <span className={`ownership-badge ${account.household_id ? 'household' : 'personal'}`}>
          {account.household_id ? <Home size={12} /> : <User size={12} />}
        </span>
      ) : null
    };
  });

  // Custom render function for options with card images
  const renderOption = (option) => (
    <div className="account-option">
      {option.cardImage ? (
        <img 
          src={option.cardImage} 
          alt="" 
          className="account-option-card-image"
        />
      ) : (
        <span className="account-option-icon">{option.icon}</span>
      )}
      <span className="account-option-label">{option.label}</span>
      {option.badge}
    </div>
  );

  // Custom render function for selected value
  const renderSelected = (option) => (
    <div className="account-selected">
      {option.cardImage ? (
        <img 
          src={option.cardImage} 
          alt="" 
          className="account-selected-card-image"
        />
      ) : (
        <span className="account-selected-icon">{option.icon}</span>
      )}
      <span className="account-selected-label">{option.label}</span>
      {option.badge}
    </div>
  );

  return (
    <CustomSelect
      options={options}
      value={value}
      onChange={onChange}
      name={name}
      disabled={disabled}
      placeholder={placeholder}
      renderOption={renderOption}
      renderSelected={renderSelected}
    />
  );
}

export default AccountSelect;
